export default defineNuxtRouteMiddleware(() => {
  const cookie = useCookie("i")
  if (!cookie.value) {
    return navigateTo("/login")
  }
})
